export const TAB_HIT_PADDING_X = 8;

export const INDICATOR_BASE_WIDTH = 200;

export type IndicatorRect = { left: number; width: number };

export const formatTransform = (rect: IndicatorRect) =>
  `translate3d(${rect.left}px, 0, 0) scaleX(${rect.width / INDICATOR_BASE_WIDTH})`;

export const measureLabelRect = (
  tab: HTMLAnchorElement,
  full = false
): IndicatorRect => {
  if (full) {
    return { left: tab.offsetLeft, width: tab.offsetWidth };
  }
  const padX =
    parseFloat(getComputedStyle(tab).paddingLeft) || TAB_HIT_PADDING_X;
  return {
    left: tab.offsetLeft + padX,
    width: tab.offsetWidth - padX * 2,
  };
};
